// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xgpytmcwkanmxylhdbbb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhncHl0bWN3a2FubXh5bGhkYmJiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI0NTc4ODYsImV4cCI6MjA1ODAzMzg4Nn0.f4Od67wepwmJ1OJMAcyqDRp2DIpzifsg9S8OELGDPE4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);